import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { usePageMeta } from '../../utils/pageMeta';
import { getOblastById, getOblastByIdAndVisiblePodoblast, getPodoblastiByOblastId } from '../../server/server-kategorije-tree';
import { useUser } from '../../auth/UseUser';
import { TypeOfEtity } from '../../model/enum/typeOfEntity';
import { Oval } from 'react-loader-spinner';
import { ObrazovanjeItem } from './ObrazovanjeHome';
import { set } from 'date-fns';
import { MarkDownView } from '../common/MarkDownView';

function OblastObrazovanjeHome() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { navLista, setNavLista, returnedList, setReturnedList, setTipEtiteta } = useUser();
    const [mainList, setMainList] = useState<any[]>([]);
    const [oblast, setOdoblast] = useState<any>(null);
    usePageMeta(oblast?.naziv, oblast?.opis);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!!id) loadOblast();
    }, [id]);

    const loadOblast = async () => {
        setLoading(true);
        const resp = await getOblastByIdAndVisiblePodoblast(id);
        if (resp.status == 200) {
            const item = resp.data;
            setOdoblast(item);
            let newList: any[] = [];
            if (item.kategorija) newList.push(item.kategorija);
            if (item.podkategorija) newList.push(item.podkategorija);
            if (item.skupOblasti) newList.push(item.skupOblasti);
            newList.push(item);
            setNavLista(newList);
            setTipEtiteta(TypeOfEtity.Podoblast);
            setReturnedList(resp.data.podoblasti);
            setMainList(resp.data.podoblasti);
            setLoading(false);
        } else {
            setLoading(false);
        }
    };

    const loadPodoblasti = async (id: string | undefined) => {
        const resp = await getPodoblastiByOblastId(id);
        if (resp.status === 200) {
        }
    };

    return (
        <div className="flex-1 flex h-full flex-col items-center overflow-y-auto bg-blueDark  no-scroll">
            <div className=" obrazovanje-outer-frame-mobile lg:obrazovanje-outer-frame-web">
                <div className=" obrazovanje-inner-frame-mobile sm:obrazovanje-inner-frame-web">
                    {!loading && (
                        <>
                            <p className=" text-obrazovanje-title">
                                {!!oblast?.naziv ? oblast?.naziv + ':' : ''}
                                <MarkDownView
                                    source={oblast?.opis}
                                    nazivKlase="lekcija-opis"
                                    style={{ color: 'white', textAlign: 'left', backgroundColor: 'transparent' }}
                                />
                            </p>
                            <div className="mt-6 flex flex-col gap-3">
                                {mainList.map((item: any, index: number) => {
                                    return <ObrazovanjeItem key={index} item={item} />;
                                })}
                            </div>
                        </>
                    )}
                    {loading && (
                        <div className="w-full flex-1 flex items-center justify-center">
                            <Oval />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default OblastObrazovanjeHome;
